import React, { useState } from 'react';
import { Body, Box, Button, Heading } from '@hover/blueprint';
import PlayCircleFilled from '../../../assets/svgs/PlayCircleFilled';
import VideoModal from './VideoModal';

const TextContent = () => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false);
  const [isVideoVertical, setIsVideoVertical] = useState<boolean>(false);

  const handleOpenVideoModal = (isVertical?: boolean) => {
    setIsVideoModalOpen(true);
    setIsVideoVertical(Boolean(isVertical));
  };

  const handleCloseVideoModal = () => {
    setIsVideoModalOpen(false);
    setIsVideoVertical(false);
  };
  return (
    <Box
      flexDir="column"
      alignItems="center"
      maxW="640px"
      my={{ base: '50px', tablet: '55px' }}
      mb={{ base: 700, tablet: 900 }}
      px={{ base: '1rem', tablet: '0px' }}
    >
      <Body
        size={300}
        fontWeight={700}
        letterSpacing="1.8px"
        textTransform="uppercase"
        sx={{ mb: { base: 4 } }}
      >
        AN INTERACTIVE SALES TOOL
      </Body>
      <Heading
        size={{ base: 600, tablet: 700 }}
        sx={{ mb: { base: 4 } }}
        textAlign="center"
      >
        Designs that help you sell
      </Heading>
      <Body
        size={{ base: 500, tablet: 600 }}
        sx={{ mb: { base: 4 } }}
        textAlign="center"
      >
        Give customers the confidence to sign the contract by showing them
        exactly what their home can look like in photo-realistic detail, with
        Design Orders.
      </Body>
      <Button
        bg="brandNavy.900"
        px="25px"
        py="32px"
        fontSize="14px"
        lineHeight="16px"
        letterSpacing="0.42px"
        _hover={{ backgroundColor: 'brandNavy.800 !important' }}
        onClick={() => handleOpenVideoModal()}
      >
        <Box as="span" mr="1rem">
          HOW IT WORKS
        </Box>
        <PlayCircleFilled />
      </Button>
      <VideoModal
        isOpen={isVideoModalOpen}
        onClose={handleCloseVideoModal}
        isVertical={isVideoVertical}
      />
    </Box>
  );
};

export default TextContent;
